import React from 'react';
import { IonIcon } from '@ionic/react';
import { logoGithub, logoLinkedin, logoDiscord } from 'ionicons/icons';
import './SocialLinks.css';

/**
 * Single source of truth for Zibby's external/social links.
 * Used by both PublicNav (header) and PublicFooter. Add/replace a URL here
 * and it updates everywhere — never hard-code these links inline again.
 */
const SOCIAL_LINKS = [
  { id: 'github', href: 'https://github.com/ZibbyDev', label: 'Zibby on GitHub', icon: logoGithub },
  { id: 'linkedin', href: 'https://www.linkedin.com/company/zibby-dev', label: 'Zibby on LinkedIn', icon: logoLinkedin },
  { id: 'discord', href: 'https://discord.gg/zgw5YPHrv', label: 'Join the Zibby Discord', icon: logoDiscord },
];

/**
 * Atomic row of external social icon links.
 * @param {string} [className] context class (e.g. public-footer-socials,
 *   public-nav-socials) for placement/color overrides — the base layout +
 *   hover live in SocialLinks.css.
 */
const SocialLinks = ({ className = '' }) => (
  <div className={`social-links ${className}`.trim()}>
    {SOCIAL_LINKS.map(({ id, href, label, icon }) => (
      <a
        key={id}
        href={href}
        target="_blank"
        rel="noopener noreferrer"
        aria-label={label}
        className="social-link"
      >
        <IonIcon icon={icon} aria-hidden="true" />
      </a>
    ))}
  </div>
);

export default SocialLinks;
export { SOCIAL_LINKS };
